const API_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:8080"
    : import.meta.env.VITE_API_URL;

async function getInterview(id) {
  try {
    const res = await fetch(
      `${API_URL}/api/interview/${encodeURIComponent(id)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    if (!res.ok) {
      console.log(res);
      return false;
    }

    const interview = await res.json();
    return interview;
  } catch (e) {
    console.log(e);
    return null;
  }
}

async function getAzureToken() {
  try {
    const res = await fetch(`${API_URL}/api/speech-token`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) {
      console.log(res);
      return null;
    }

    const token = await res.json();
    return token;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// Sends an answer to generate individual feedback during interview
async function sendAnswer(question, answer, interviewId, i) {
  try {
    const res = await fetch(`${API_URL}/api/feedback/question`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question, answer, interviewId, i }),
    });

    if (!res.ok) {
      console.log(res);
      return null;
    }

    const response = await res.json();
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// Generate general feedback
async function generateFeedback(interviewId) {
  try {
    console.log(`Generating general feedback for interview ${interviewId}`);
    const res = await fetch(`${API_URL}/api/feedback/general`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ interviewId }),
    });

    if (!res.ok) {
      console.log(res);
      return null;
    }

    const response = await res.json();
    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// Fetch feedback given id
async function fetchFeedback(id) {
  try {
    const res = await fetch(
      `${API_URL}/api/feedback/${encodeURIComponent(id)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
    );

    if (!res.ok) {
      console.log(res);
      return null;
    }

    const response = await res.json();
    return response.feedback;
  } catch (e) {
    console.log(e);
    return null;
  }
}

export {
  getInterview,
  getAzureToken,
  sendAnswer,
  generateFeedback,
  fetchFeedback,
};
